export const BookDemoLink = () => {
  const calendlyUrl = 'https://calendly.com/d/cnk4-vdw-4q5/quarter20-intro'

  return (
    <p>
      Want an account? Book a demo{' '}
      <a
        href={calendlyUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="underline text-primary-50"
      >
        here
      </a>{' '}
      or reach out to us directly at{' '}
      <a href="mailto:hello@buildquarter20.com">hello@buildquarter20.com</a>.
    </p>
  )
}
